import {
  Button,
  Checkbox,
  ConfigProgrammatic,
  Dropdown,
  Datepicker,
  Field,
  Icon,
  Input,
  Loading,
  Modal,
  Radio,
  Upload,
} from 'buefy'

import BaseIcon from './BaseIcon.vue'

export default function (app) {
  app.use(Button)
  app.use(Checkbox)
  app.use(Dropdown)
  app.use(Datepicker)
  app.use(Field)
  app.use(Icon)
  app.use(Input)
  app.use(Loading)
  app.use(Modal)
  app.use(Radio)
  app.use(Upload)
  app.component('base-icon', BaseIcon)

  ConfigProgrammatic.setOptions({
    defaultIconPack: '',
    defaultIconComponent: 'base-icon',
    // customIconPacks: {
    //   ph: {
    //     internalIcons: {
    //       'chevron-right': 'caret-right',
    //       'chevron-left': 'caret-left',
    //     },
    //   },
    // },
  })
}
